export const QUERY_LIMIT = 200;

export const TABS = {
	LIST: { value: 'regionOptionsTab', text: 'Options' },
	ZIPS: { value: 'regionServiceAreaTab', text: 'Service area' },
	REGIONS: { value: 'regionConfigTab', text: 'Config' }
};
export const SECTIONS = {
	info: 'info',
	technicianInfo: 'technicianInfo',
	editorInfo: 'editorInfo',
	regions: 'regions',
	adminInfo: 'adminInfo'
};
